import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './helpers/Store';
import UserAnalyticRequest from './containers/UserAnalyticRequest';
import { CookiesProvider }  from 'react-cookie';

ReactDOM.render(
    // <React.StrictMode>
    <Provider store={store}>
        <CookiesProvider>
            <UserAnalyticRequest />
            <HashRouter>
                <App />
            </HashRouter>
        </CookiesProvider>
    </Provider>
    // </React.StrictMode>,
    ,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
